import * as Yup from "yup";
import { FormGroup } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Rating } from "@bit/primefaces.primereact.rating";
import PrimereactStyle from "@bit/primefaces.primereact.internal.stylelinks";
import { Button, Col, Form, Label, Row } from "reactstrap";
import { useSpots } from "../../hooks/spots";
import FormInput from "../SpotForm/FormInput";
import Select from "react-select";
import { FormProvider, useForm, useFormState } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import moment from "moment";
import { dateObjectToInputString, getDateFromISO } from "../../util/view";

const mapSpotToSelect = (spot, index) => ({
  id: spot?.id,
  label: spot?.name,
  value: index,
});

const defaultValues = {
  description: "",
  endTime: "",
  rating: 0,
  startTime: "",
  spot: {},
};

const metadataSchema = Yup.object().shape({
  rating: Yup.number()
    .min(0)
    .max(5)
    .required("Required"),
  startTime: Yup.string().required("Required"),
  date: Yup.date().required("Required"),
  endTime: Yup.string()
    .required("Required")
    .test("is-greater", "End time should be after than start time", function(
      value
    ) {
      const { startTime } = this.parent;
      return moment(value, "HH:mm").isSameOrAfter(moment(startTime, "HH:mm"));
    }),
});

const SeshMetadata = ({ formData, next, prev }) => {
  const values = Object.keys(formData)?.length ? formData : defaultValues;

  useEffect(() => {
    setRating(values.rating);
    methods.setValue("spot", values.spot);
    methods.setValue("date", prepareDate(values.date));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const prepareDate = (date) => {
    if (typeof date === "object") {
      return dateObjectToInputString(date);
    } else if (typeof date === "string") {
      return getDateFromISO(date);
    }
  };
  const methods = useForm({
    defaultValues: values,
    resolver: yupResolver(metadataSchema),
    mode: "onTouched",
  });
  const { isValid } = useFormState({ control: methods.control });
  const { data: spots } = useSpots();
  // const printValues = () => console.log(methods.getValues());
  const [rating, setRating] = useState(0);
  const ratingClick = (event) => {
    setRating(event.value);
    methods.setValue("rating", event.value);
  };
  const spotClick = (spot) => {
    methods.setValue("spot", spots[spot.value]);
    methods.setValue("spotId", spot.id);
  };
  return (
    <>
      <Row noGutters className="mt-1">
        <Col xs="auto">
          <h2>Sesh Info</h2>
        </Col>
      </Row>
      <FormProvider {...methods}>
        <Form onSubmit={methods.handleSubmit(next)}>
          <Row form>
            <Col xs={6}>
              <FormGroup>
                <Label for="spotId">
                  Spot<span style={{ color: "#d04437" }}>*</span>
                </Label>
                <Select
                  options={spots?.map(mapSpotToSelect)}
                  onChange={spotClick}
                  defaultValue={mapSpotToSelect(
                    spots?.find((spot) => spot.id === values.spot?.id),
                    spots?.findIndex((spot) => spot.id === values.spot?.id)
                  )}
                />
              </FormGroup>
            </Col>
            <Col xs="auto" sm={{ size: "auto", offset: 1 }}>
              <FormGroup>
                <Label for="rating">
                  Rating<span style={{ color: "#d04437" }}>*</span>
                </Label>
                <PrimereactStyle />
                <Rating
                  className="star-rating-form"
                  value={rating}
                  cancel={false}
                  onChange={ratingClick}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row form className="mt-1">
            <Col xs={12} md={4}>
              <FormInput
                bsSize="sm"
                name="date"
                type="date"
                label="Date"
                required
              />
            </Col>
            <Col xs={6} md={4}>
              <FormInput
                bsSize="sm"
                name="startTime"
                type="time"
                label="Start Time"
                required
              />
            </Col>
            <Col xs={6} md={4}>
              <FormInput
                bsSize="sm"
                name="endTime"
                type="time"
                label="End Time"
                required
              />
            </Col>
          </Row>
          <Row form className="mt-1">
            <Col xs={12}>
              <FormInput
                name="description"
                type="textarea"
                label="Description"
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col xs="auto">
              <Button onClick={prev}>Cancel</Button>
            </Col>
            <Col xs="auto" className="ml-auto">
              <Button color="primary" type="submit" disabled={!isValid}>
                Next
              </Button>
            </Col>
          </Row>
        </Form>
      </FormProvider>
    </>
  );
};

export default SeshMetadata;
